/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_discord_join = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the server`)
};

const es_contact_discord_join = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete al servidor`)
};

const de_contact_discord_join = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Server beitreten`)
};

const nl_contact_discord_join = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word lid van de server`)
};

const fr_contact_discord_join = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre le serveur`)
};

const it_contact_discord_join = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entra nel server`)
};

const pt_br2_contact_discord_join = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar no servidor`)
};

const pt_contact_discord_join = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juntar-me ao servidor`)
};

const ja_contact_discord_join = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サーバーに参加`)
};

const zh_contact_discord_join = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入服务器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_discord_join = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_discord_join(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_discord_join", locale)
	if (locale === "en") return en_contact_discord_join(inputs)
	if (locale === "es") return es_contact_discord_join(inputs)
	if (locale === "de") return de_contact_discord_join(inputs)
	if (locale === "nl") return nl_contact_discord_join(inputs)
	if (locale === "fr") return fr_contact_discord_join(inputs)
	if (locale === "it") return it_contact_discord_join(inputs)
	if (locale === "pt-BR") return pt_br2_contact_discord_join(inputs)
	if (locale === "pt") return pt_contact_discord_join(inputs)
	if (locale === "ja") return ja_contact_discord_join(inputs)
	return zh_contact_discord_join(inputs)
};